// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1RoleSchema } from './v1/roleSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const listRolesPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const listRolesHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Roles list retrieved successfully
 */
export const listRoles200Schema = z.array(z.lazy(() => v1RoleSchema));

/**
 * @description Unauthorized
 */
export const listRoles401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

export const listRolesQueryResponseSchema = z.lazy(() => listRoles200Schema);
